/* eslint-disable consistent-return */
var printers = require('../binary-operator-printers');

var BinaryOperation = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print,
        options = _ref.options;
    var printerKeys = Object.keys(printers);

    for (var i = 0, len = printerKeys.length; i < len; i += 1) {
      if (printers[printerKeys[i]].match(node.operator)) return printers[printerKeys[i]].print(node, path, _print, options);
    }
  }
};
module.exports = BinaryOperation;